import {
	Button,
	Checkbox,
	Col,
	Divider,
	Form,
	Input,
	Popconfirm,
	Row,
	Select,
	Typography,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
const { Text, Title } = Typography;

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Plant",
		dataIndex: "plant",
		key: "plant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Subplant",
		dataIndex: "subplant",
		key: "subplant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const Batch = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [plantOptions, setPlantOptions] = useState([]);
	const [subplantOptions, setSublantOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [loadingSubplant, setLoadingSubplant] = useState(true);
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [apiNotification, contextHolder] = notification.useNotification();
	const [historyData, setHistoryData] = useState([]);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlant();
		getBatch();
	}, []);

	const getPlant = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptions(plantList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSublant = async (currentPlant) => {
		const url = api + `/plant/${currentPlant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let subplantList = [];
			data.subplants.map((item) => {
				subplantList.push({
					label: item.name,
					value: item.name,
				});
			});
			setSublantOptions(subplantList);
			setLoadingSubplant(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getBatch = async () => {
		const url = api + "/users/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setInitialValues({
				...initialValues,
				name: data.name,
				email: data.email,
				plant: data.plant,
				subplant: data.subplant,
				prefix: "+1",
				phone: data.phone ? data.phone.substring(2) : "",
				active:
					data.active !== null && data.active !== undefined
						? data.active
						: true,
			});
			setPhone(data.phone);
			setEmail(data.email);
			getSublant(data.plant);

			let history = [];

			data.batchHistory.map((item, key) =>
				history.push({
					key: key,
					date: Intl.DateTimeFormat("en-US", {
						month: "numeric",
						year: "numeric",
						day: "numeric",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
					}).format(new Date(item.createdAt)),
					plant: item.plant.name,
					subplant: item.subplant,
				})
			);

			setHistoryData(history);

			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get user");
			console.error(err.message);
			return null;
		}
	};

	const deleteBatch = async () => {
		setLoading(true);

		const url = api + "/users/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Batch Deleted");
			setLoading(false);
			props.history.push("/batch/list");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserEmail = async (email) => {
		const url = api + "/useremail/" + email;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserPhone = async (phone) => {
		const url = api + `/userphone/+1${phone}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const updateBatch = async (data) => {
		const user = {
			name: data.name,
			email: data.email,
			plant: data.plant,
			subplant: data.subplant,
			phone: `+1${data.phone}`,
			active: data.active || false,
		};

		try {
			let url = api + "/users/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, user);
			openNotification("success", "Success", "Batch updated");
			setLoading(false);
			props.history.push("/batch/list");
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update user");
			console.error(err.message);
			return null;
		}
	};

	const validateUser = async (values) => {
		if ("+1" + values.phone === phone && values.email === email) {
			updateBatch(values);
		} else {
			let duplicadoEmail = false;
			let duplicadoPhone = false;

			if (values.email !== email) {
				duplicadoEmail = await duplicatedUserEmail(values.email);
			}
			if ("+1" + values.phone !== phone) {
				duplicadoPhone = await duplicatedUserPhone(values.phone);
			}

			if (duplicadoEmail) {
				openNotification(
					"warning",
					"Duplicated user",
					"User already exist with Email"
				);
				setLoading(false);
			} else if (duplicadoPhone) {
				openNotification(
					"warning",
					"Duplicated user",
					"User already exist with Phone"
				);
				setLoading(false);
			} else {
				updateBatch(values);
			}
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		validateUser(values);
	};

	const onChangePlant = (value) => {
		form.setFieldsValue({ subplant: "" });
		setLoadingSubplant(true);
		getSublant(value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Select.Option value="+1">+1</Select.Option>
			</Select>
		</Form.Item>
	);

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Email"
							name="email"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Phone"
							name="phone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Plant"
							name="plant"
							rules={[
								{
									required: true,
									message: "Please select a plant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select plant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={plantOptions}
								onChange={onChangePlant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Subplant"
							name="subplant"
							rules={[
								{
									required: true,
									message: "Please select a subplant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select subplant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={subplantOptions}
								disabled={loadingSubplant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item name="active" valuePropName="checked">
							<Checkbox>Active</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable columns={columns} data={historyData} isScroll={false} />
				<Divider />
				<Row gutter={16}>
					<Col>
						<Button type="primary" htmlType="submit" loading={loading}>
							Save
						</Button>
					</Col>
					{/* <Col>
                    <Popconfirm
                        title="Delete the user"
                        description="Are you sure to delete this user?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={deleteBatch}
                    >
                        <Button danger type='primary' htmlType='button' loading={loading}>Delete</Button>
                    </Popconfirm>
                </Col> */}
				</Row>
			</Form>
		);
	};

	return (
		<Layout title="Batch" description="Edit Batch" type="medium">
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default Batch;
